import { graphql } from '@teachino/shared-infrastructure';
import { topicListItemFragment } from './folders/topic-list-item';

export const createTopicMutation = graphql(
  `
    mutation CreateTopic($name: String!, $goals: String, $folderId: String) {
      createTopic(
        createTopicInput: {
          name: $name
          goals: $goals
          libraryFolderId: $folderId
          position: -1
        }
      ) {
        __typename
        topic {
          ...TopicListItem
        }
      }
    }
  `,
  [topicListItemFragment],
);
